 import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
 
import {appApiResources} from '../../../configuration/app.constants';

@Injectable({
  providedIn: 'root'
})
export class SearchEventService {

  constructor(private http: HttpClient) {}

  async getEventList() {
    try {
      // const httpOptions = {
      //   headers: new HttpHeaders({
      //     "Content-Type": "application/json",
      //     Authorization: `jwt ${idToken}`
      //   })
      // }; 
      let response = await this.http
        .get(`${appApiResources.getEventList}`)
        .toPromise();
      return response;
    } catch (error) { 
      return error;
    }
  }
}